import { BuildingIcon, CheckCircleIcon } from './icons';
import { HopperIcon } from './icons/HopperIcon';

export type VenueCardMiniProps = {
  name: string;
  cuisine?: string | null;
  address?: string | null;
  imageUrl?: string | null;
  verdictsCount?: number;
  visitsCount?: number | null;
  guestsCount?: number | null;
  verified?: boolean;
  showMeta?: boolean;
  showAddressPin?: boolean;
  onClick?: () => void;
  className?: string;
};

export function VenueCardMini({
  name,
  cuisine,
  address,
  imageUrl,
  verdictsCount = 0,
  visitsCount,
  guestsCount,
  verified = false,
  showMeta = true,
  showAddressPin = false,
  onClick,
  className,
}: VenueCardMiniProps) {
  const hasVisitStats = visitsCount !== undefined || guestsCount !== undefined;

  const content = (
    <>
      <span className="hopper-venue-mini__media">
        {imageUrl ? <img src={imageUrl} alt="" loading="lazy" /> : <BuildingIcon size={24} />}
      </span>
      <span className="hopper-venue-mini__body">
        <span className="hopper-venue-mini__title-row">
          <strong>{name}</strong>
          {verified && <CheckCircleIcon size={16} color="var(--color-primary)" />}
        </span>
        {cuisine && <span className="hopper-venue-mini__cuisine">{cuisine}</span>}
        {address && (
          <span className={showAddressPin ? 'hopper-venue-mini__address hopper-venue-mini__address--with-pin' : 'hopper-venue-mini__address'}>
            {showAddressPin && <HopperIcon name="pin" size={14} />}
            <span>{address}</span>
          </span>
        )}
        {showMeta && (hasVisitStats ? (
          <span className="hopper-venue-mini__stats">
            <span>{visitsCount ?? '—'} визитов</span>
            <span>{guestsCount ?? '—'} гостей</span>
          </span>
        ) : (
          <span className="hopper-venue-mini__verdicts">
            {verdictsCount > 0 ? `${verdictsCount} впечатлений` : 'Пока нет впечатлений'}
          </span>
        ))}
      </span>
    </>
  );

  const classes = ['hopper-venue-mini', onClick ? 'is-interactive' : '', className].filter(Boolean).join(' ');

  if (onClick) {
    return <button className={classes} type="button" onClick={onClick}>{content}</button>;
  }

  return <div className={classes}>{content}</div>;
}
